module.exports = __webpack_public_path__ + "img/tabla-header-2.6b63bbe0.svg";